export var EmailStatus;
(function (EmailStatus) {
    EmailStatus[EmailStatus["Init"] = 0] = "Init";
    EmailStatus[EmailStatus["Sending"] = 1] = "Sending";
    EmailStatus[EmailStatus["Sended"] = 3] = "Sended";
    EmailStatus[EmailStatus["Failed"] = 4] = "Failed";
    EmailStatus[EmailStatus["Canceled"] = 5] = "Canceled";
    EmailStatus[EmailStatus["Trash"] = 6] = "Trash";
})(EmailStatus || (EmailStatus = {}));
export var ProviderType;
(function (ProviderType) {
    ProviderType["All"] = "All";
    ProviderType["Gmail"] = "Gmail";
    ProviderType["Outlook"] = "Outlook";
    ProviderType["Others"] = "Others";
})(ProviderType || (ProviderType = {}));
export var WarmUpAccountSource;
(function (WarmUpAccountSource) {
    WarmUpAccountSource[WarmUpAccountSource["system"] = 0] = "system";
    WarmUpAccountSource[WarmUpAccountSource["custom"] = 1] = "custom";
})(WarmUpAccountSource || (WarmUpAccountSource = {}));
export var CustomerAttribute;
(function (CustomerAttribute) {
    CustomerAttribute[CustomerAttribute["LABEL"] = 0] = "LABEL";
    CustomerAttribute[CustomerAttribute["CUSTOMER_STAGE"] = 1] = "CUSTOMER_STAGE";
    CustomerAttribute[CustomerAttribute["CUSTOMER_LEVEL"] = 2] = "CUSTOMER_LEVEL";
    CustomerAttribute[CustomerAttribute["AREA"] = 3] = "AREA";
    CustomerAttribute[CustomerAttribute["CREATE_TYPE"] = 4] = "CREATE_TYPE";
    CustomerAttribute[CustomerAttribute["STAR_LEVEL"] = 5] = "STAR_LEVEL";
    CustomerAttribute[CustomerAttribute["SOURCE"] = 6] = "SOURCE";
    CustomerAttribute[CustomerAttribute["STATUS"] = 7] = "STATUS";
})(CustomerAttribute || (CustomerAttribute = {}));
export var ReplyTabEnum;
(function (ReplyTabEnum) {
    ReplyTabEnum["AVAILABLE"] = "AVAILABLE";
    ReplyTabEnum["CONCEAL"] = "CONCEAL";
    ReplyTabEnum["UNAVAILABLE"] = "UNAVAILABLE";
})(ReplyTabEnum || (ReplyTabEnum = {}));
export var SubjectId;
(function (SubjectId) {
    SubjectId[SubjectId["sendRate"] = 1] = "sendRate";
    SubjectId[SubjectId["openRate"] = 2] = "openRate";
    SubjectId[SubjectId["replyRate"] = 3] = "replyRate";
})(SubjectId || (SubjectId = {}));
export var EdmEmailType;
(function (EdmEmailType) {
    EdmEmailType[EdmEmailType["CREATE_EMAIL"] = 0] = "CREATE_EMAIL";
    EdmEmailType[EdmEmailType["USE_TEMPLATE"] = 2] = "USE_TEMPLATE";
})(EdmEmailType || (EdmEmailType = {}));
